import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import css from './ShopNewByBrand.module.css';

/**
 * "Shop New by Brand": one slot per brand, each linking to a partner dealer's NEW inventory for that
 * brand, opened in a new tab.
 *
 * Each slot shows the brand only ("Shop New Ford"), never the dealership, by Nik's decision
 * (2026-10-25). Every URL below was loaded on 2026-10-25 and listed only that brand's new vehicles.
 *
 * `logo` is empty for every brand: no OEM logo file with permission to use it has reached the
 * repository, and Ford, GM, Kia, Stellantis and Audi all restrict logo use. Until one is supplied the
 * slot shows the brand name as type. Supplying a file is a one-line change per brand.
 */
export const BRAND_SLOTS = [
  { brand: 'Ford', url: 'https://www.rivercityford.ca/vehicles/new/', logo: null },
  { brand: 'GMC', url: 'https://www.mcnaught.com/new-inventory/make/gmc/', logo: null },
  { brand: 'Buick', url: 'https://www.mcnaught.com/new-inventory/make/buick/', logo: null },
  { brand: 'Cadillac', url: 'https://www.mcnaughtcadillac.com/new-inventory/', logo: null },
  { brand: 'Dodge', url: 'https://www.waverleychrysler.ca/new/inventory/Dodge.html', logo: null },
  {
    brand: 'Chrysler',
    url: 'https://www.waverleychrysler.ca/new/inventory/Chrysler.html',
    logo: null,
  },
  { brand: 'Kia', url: 'https://www.jimgauthierkia.com/inventory/new/', logo: null },
  { brand: 'Audi', url: 'https://www.audiwinnipeg.com/en/inventory/new/', logo: null },
];

const HEADING_ID = 'ShopNewByBrand-heading';

export default function ShopNewByBrand({ slots = BRAND_SLOTS }) {
  const intl = useIntl();
  return (
    <section className={css.root} aria-labelledby={HEADING_ID}>
      <h2 id={HEADING_ID} className={css.heading}>
        <FormattedMessage id="ShopNewByBrand.heading" />
      </h2>
      <ul className={css.grid}>
        {slots.map(({ brand, url, logo }) => (
          <li key={brand}>
            <a
              className={css.slot}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={intl.formatMessage({ id: 'ShopNewByBrand.ariaLabel' }, { brand })}
            >
              {logo ? (
                <img className={css.logo} src={logo} alt="" />
              ) : (
                <span className={css.wordmark} aria-hidden="true">
                  {brand}
                </span>
              )}
              <span className={css.label} aria-hidden="true">
                <FormattedMessage id="ShopNewByBrand.slotLabel" values={{ brand }} />
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
